import {
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client/core/types';
import { emptyCustomer } from 'components/auth/authConstants';
import * as React from 'react';
import { Subscription } from 'stores/subscriptionStore';
import { Customer, Query } from 'types/generatedSchemaTypes';
import { DecodedAccessTokenType } from 'utils/accessTokenUtils';

export type AccountContextProps = {
  customer: Customer;
  error?: Error;
  loading?: boolean;
  benefitsLoading?: boolean;
  decodedToken?: DecodedAccessTokenType;
  customerSubscription?: Subscription;
  customerSubscriptionLoading?: boolean;
  isSubscriptionPaymentFailed?: boolean;
  memberGroupUids: string[];
  refetchCustomer: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloQueryResult<Query>> | undefined;
  refetchPermits: () => Promise<ApolloQueryResult<Query>> | undefined;
  refetchBenefits: () => Promise<ApolloQueryResult<Query>> | undefined;
  refetchCustomerSubscription: () =>
    | Promise<ApolloQueryResult<Query>>
    | undefined;
};

export const accountContextDefaultValue: AccountContextProps = {
  customer: {
    ...emptyCustomer,
  },
  error: undefined,
  loading: false,
  benefitsLoading: false,
  memberGroupUids: [],
  customerSubscription: undefined,
  customerSubscriptionLoading: false,
  isSubscriptionPaymentFailed: false,
  refetchCustomer: () => undefined,
  refetchPermits: () => undefined,
  refetchBenefits: () => undefined,
  refetchCustomerSubscription: () => undefined,
};

const AccountContext = React.createContext<AccountContextProps>(
  accountContextDefaultValue
);

export default AccountContext;
